const NS = 'HubItemWidget';
const CLS = 'hubItemWidget';

import { handleTruncate } from '../../../../global/js/truncate';

export class HubItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.limit = 300; // reserved limit (characters)
		this.$summary = this.$element.find(`.${CLS}-desc`);
		this.summaryHtml = this.$summary.html();
		this.summaryText = this.$summary.text(); // for comparison without the extra characters from html tags
		this.originalHtml = this.summaryHtml;

		// handle truncate (read more / read less)
		handleTruncate(this);
	}
}
